import { requestJson } from "@/lib/api";
import type { CartItem } from "@/lib/types";

interface CartItemDto {
  id: string;
  productId: string;
  productName: string;
  emoji: string;
  category: string;
  cut: string;
  unit: string;
  quantity: number;
  deliveryWindow?: string | null;
  notes?: string | null;
  pricePerUnit?: number | null;
  smallQuantitySurcharge?: boolean;
}

function toCartItem(item: CartItemDto): CartItem {
  return {
    id: item.id,
    productId: item.productId,
    productName: item.productName,
    emoji: item.emoji,
    category: item.category,
    cut: item.cut,
    unit: item.unit,
    quantity: item.quantity,
    deliveryWindow: item.deliveryWindow ?? undefined,
    notes: item.notes ?? undefined,
    pricePerUnit: item.pricePerUnit ?? undefined,
    smallQuantitySurcharge: item.smallQuantitySurcharge ?? false,
  };
}

function toPayload(item: CartItem): CartItemDto {
  return {
    id: item.id,
    productId: item.productId,
    productName: item.productName,
    emoji: item.emoji,
    category: item.category,
    cut: item.cut,
    unit: item.unit,
    quantity: item.quantity,
    deliveryWindow: item.deliveryWindow ?? null,
    notes: item.notes ?? null,
    pricePerUnit: item.pricePerUnit ?? null,
  };
}

export async function fetchCart(deliveryUnitId?: string): Promise<CartItem[]> {
  const query = deliveryUnitId ? `?deliveryUnitId=${encodeURIComponent(deliveryUnitId)}` : "";
  const cart = await requestJson<CartItemDto[]>(`/api/v1/cart${query}`);
  return cart.map(toCartItem);
}

export async function replaceCart(items: CartItem[]): Promise<CartItem[]> {
  const cart = await requestJson<CartItemDto[]>("/api/v1/cart", {
    method: "PUT",
    body: items.map(toPayload),
  });
  return cart.map(toCartItem);
}

export async function clearCart(): Promise<void> {
  await requestJson<void>("/api/v1/cart", {
    method: "DELETE",
  });
}
